
import { initializeApp } from "firebase/app";
import { 
  getFirestore, 
  collection, 
  onSnapshot, 
  setDoc, 
  doc, 
  deleteDoc, 
  query
} from "firebase/firestore";

let db: any = null;

export const initFirebase = (config: any) => {
  try {
    const app = initializeApp(config);
    db = getFirestore(app);
    return db;
  } catch (error) {
    console.error("Firebase Init Error:", error);
    return null;
  }
};

export const syncCollection = (
  collectionName: string, 
  callback: (data: any[]) => void, 
  onError?: (error: any) => void
) => {
  if (!db) return () => {};
  const q = query(collection(db, collectionName));
  
  return onSnapshot(q, 
    (snapshot) => {
      const items: any[] = [];
      snapshot.forEach((doc) => {
        items.push({ ...doc.data(), id: doc.id });
      });
      callback(items);
    },
    (error) => {
      console.error(`Error syncing ${collectionName}:`, error);
      if (onError) onError(error);
    }
  );
};

export const saveData = async (collectionName: string, id: string, data: any) => {
  if (!db) throw new Error("Database not initialized");
  try {
    await setDoc(doc(db, collectionName, id), data, { merge: true });
  } catch (error) {
    console.error(`Error saving to ${collectionName}:`, error);
    throw error;
  }
};

export const removeData = async (collectionName: string, id: string) => {
  if (!db) throw new Error("Database not initialized");
  try {
    await deleteDoc(doc(db, collectionName, id));
  } catch (error) {
    console.error(`Error removing from ${collectionName}:`, error);
    throw error;
  }
};

export const uploadBulk = async (collectionName: string, items: any[]) => {
  if (!db) throw new Error("Database not initialized");
  // Menggunakan per-item setDoc karena batch sering terkendala limit atau rules kompleks di awal
  const promises = items.map(item => {
    const id = item.id || `item-${Date.now()}-${Math.random()}`;
    return setDoc(doc(db, collectionName, id), item);
  });
  
  try {
    await Promise.all(promises);
  } catch (error) {
    console.error(`Bulk upload failed for ${collectionName}:`, error);
    throw error;
  }
};
